import { useArgoDesign } from "./context-U293r3v-.js";
import { FieldBox } from "./FieldBox-BrxLkY9C.js";
import { useId } from "react";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
import { Root, Thumb } from "@radix-ui/react-switch";
//#region src/components/Switch/styles.ts
const switchVariants = cva([
	"tailwindcss-preflight",
	"tw:shrink-0",
	"tw:cursor-pointer",
	"tw:disabled:cursor-not-allowed",
	"tw:disabled:opacity-disabled"
], {
	defaultVariants: {
		size: "medium",
		variant: "default"
	},
	variants: {
		variant: {
			default: [
				"tw:peer/switch",
				"tw:group/switch",
				"tw:relative",
				"tw:flex",
				"tw:items-center",
				"tw:gap-2",
				"tw:min-h-5",
				"tw:text-neutral-800",
				"tw:font-normal",
				"tw:before:content-[\" \"]",
				"tw:before:block",
				"tw:before:relative",
				"tw:aria-checked:before:bg-primary-500",
				"tw:before:bg-neutral-200",
				"tw:aria-checked:before:hover:bg-primary-600",
				"tw:before:hover:bg-neutral-300",
				"tw:disabled:hover:before:bg-neutral-200",
				"tw:transition-colors",
				"tw:focus-visible:outline-hidden",
				"tw:focus-visible:before:outline",
				"tw:focus-visible:before:outline-1",
				"tw:focus-visible:before:outline-ring",
				"tw:focus-visible:before:ring-4",
				"tw:focus-visible:before:ring-ring/30"
			],
			argo: [
				"tw:peer",
				"tw:inline-flex",
				"tw:items-center",
				"tw:w-9",
				"tw:h-5",
				"tw:rounded-full",
				"tw:border",
				"tw:border-transparent",
				"tw:bg-input",
				"tw:transition-colors",
				"tw:data-[state=checked]:bg-primary",
				"tw:focus-visible:outline-hidden",
				"tw:focus-visible:border-primary",
				"tw:focus-visible:ring-3",
				"tw:focus-visible:ring-ring/50"
			]
		},
		size: {
			small: [],
			medium: [],
			large: []
		}
	},
	compoundVariants: [
		{
			variant: "default",
			size: "small",
			class: [
				"tw:before:w-6",
				"tw:before:h-4",
				"tw:before:rounded-lg"
			]
		},
		{
			variant: "default",
			size: "medium",
			class: [
				"tw:before:w-8",
				"tw:before:h-4",
				"tw:before:rounded-lg"
			]
		},
		{
			variant: "default",
			size: "large",
			class: [
				"tw:before:w-10",
				"tw:before:h-5",
				"tw:before:rounded-xl"
			]
		}
	]
});
const thumbVariants = cva([
	"tw:block",
	"tw:shrink-0",
	"tw:pointer-events-none",
	"tw:bg-white",
	"tw:rounded-full"
], {
	defaultVariants: {
		size: "medium",
		variant: "default"
	},
	variants: {
		variant: {
			default: [
				"tw:absolute",
				"tw:left-0",
				"tw:transition-transform",
				"tw:ease-in-out",
				"tw:shadow-[0_2px_5px_rgba(0,0,0,.26)]"
			],
			argo: [
				"tw:size-4",
				"tw:shadow-sm",
				"tw:transition-transform",
				"tw:data-[state=checked]:translate-x-[16px]",
				"tw:data-[state=unchecked]:translate-x-0.5"
			]
		},
		size: {
			small: [],
			medium: [],
			large: []
		}
	},
	compoundVariants: [
		{
			variant: "default",
			size: "small",
			class: [
				"tw:w-3",
				"tw:h-3",
				"tw:data-[state=checked]:translate-x-2.5",
				"tw:data-[state=unchecked]:translate-x-0.5"
			]
		},
		{
			variant: "default",
			size: "medium",
			class: [
				"tw:w-3",
				"tw:h-3",
				"tw:data-[state=checked]:translate-x-[18px]",
				"tw:data-[state=unchecked]:translate-x-0.5"
			]
		},
		{
			variant: "default",
			size: "large",
			class: [
				"tw:w-3.5",
				"tw:h-3.5",
				"tw:data-[state=checked]:translate-x-6",
				"tw:data-[state=unchecked]:translate-x-0.5"
			]
		}
	]
});
//#endregion
//#region src/components/Switch/Switch.tsx
const Switch = ({ ref, className, size, disabled = false, id: idProp, children, description, variant, position, ...props }) => {
	const fallbackId = useId();
	const id = idProp?.toString() ?? fallbackId;
	const switchVariant = useArgoDesign() ? "argo" : "default";
	const switchElement = /* @__PURE__ */ jsx(Root, {
		...props,
		ref,
		id,
		disabled,
		className: switchVariants({
			className,
			size,
			variant: switchVariant
		}),
		children: /* @__PURE__ */ jsx(Thumb, { className: thumbVariants({
			size,
			variant: switchVariant
		}) })
	});
	if (!children) return switchElement;
	return /* @__PURE__ */ jsxs(FieldBox, {
		htmlFor: id,
		variant,
		position,
		control: switchElement,
		children: [/* @__PURE__ */ jsx(FieldBox.Title, { children }), description && /* @__PURE__ */ jsx(FieldBox.Description, { children: description })]
	});
};
//#endregion
export { Switch };

//# sourceMappingURL=Switch-Dw4tvQls.js.map